const SERVICE_SLUGS = [
  "credito-rural",
  "avaliacoes",
  "laudos-tecnicos",
  "pericias-judiciais",
  "regularizacao-rural",
  "assessoria",
  "reestruturacao-de-dividas-rurais",
  "seguro-agricola",
];

// Copy factual: só o que a empresa informou ou processo descritivo genérico.
// Dados faltantes são omitidos (o bloco correspondente não é exibido no site).
// Título (≤60) e meta description (140–155, única por página) servidos no HTML.
const SERVICE_SEO = {
  "credito-rural": {
    title: "Projetos de Crédito Rural em Pelotas/RS | Melo Agro",
    desc: "Projeto técnico e orçamento para custeio e investimento no Plano Safra (Pronaf, Pronamp, RenovAgro), prontos para a análise do banco, com ART.",
  },
  "avaliacoes": {
    title: "Avaliações de Imóveis e Máquinas em Pelotas/RS | Melo Agro",
    desc: "Descubra quanto vale o seu imóvel rural ou urbano com laudo de avaliação conforme a ABNT NBR 14653, para crédito, inventário e partilha, com ART.",
  },
  "laudos-tecnicos": {
    title: "Laudos Técnicos Agronômicos em Pelotas/RS | Melo Agro",
    desc: "Comprove a situação e a produtividade da sua lavoura com laudo técnico agronômico assinado por engenheiro civil e agrônomo, com ART no CREA-RS.",
  },
  "pericias-judiciais": {
    title: "Perícias Agrícolas e Judiciais em Pelotas/RS | Melo Agro",
    desc: "Reforce o seu processo com perícia agrícola e judicial assinada por engenheiro civil e agrônomo, com quesitos, vistoria e laudo fundamentado.",
  },
  "regularizacao-rural": {
    title: "Regularização Rural em Pelotas/RS | Melo Agro",
    desc: "Resolva CAR, CCIR, ITR e a documentação do imóvel rural com quem une agronomia e engenharia civil, direto de Pelotas para toda a Metade Sul do RS.",
  },
  "assessoria": {
    title: "Assessoria Especializada em Pelotas/RS | Melo Agro",
    desc: "Tire dúvidas de crédito rural, contratos e documentação com assessoria técnica que reúne agronomia e engenharia civil, com ART quando cabível.",
  },
  "reestruturacao-de-dividas-rurais": {
    title: "Reestruturação de Crédito Rural em Pelotas/RS | Melo Agro",
    desc: "Reorganize as dívidas da sua produção rural com levantamento técnico e plano de renegociação para apresentar ao banco ou à cooperativa de crédito.",
  },
  "seguro-agricola": {
    title: "Seguros Agrícolas em Pelotas/RS | Melo Agro",
    desc: "Contrate o seguro da sua lavoura com orientação técnica de um engenheiro e conte com vistoria e perícia de sinistro quando a perda acontecer.",
  },
};

const SERVICES_DATA = {
  "credito-rural": {
    title: "Projetos de Crédito Rural",
    image: "/img/soja-fileiras.webp",
    intro: "Elaboração de projeto técnico e orçamento para linhas de custeio e investimento — Pronaf, Pronamp, RenovAgro e demais linhas do Plano Safra — com documentação pronta para o agente financeiro.",
    waMsg: "Olá! Gostaria de conversar sobre um projeto de crédito rural.",
    audiences: [
      { t: "Produtores rurais", d: "Acesso às linhas certas do Plano Safra, com projeto técnico bem estruturado para a análise do banco." },
      { t: "Advogados e escritórios", d: "Documentação técnica e orçamentos para operações e processos de clientes rurais." },
      { t: "Bancos e cooperativas", d: "Projetos completos e fundamentados, prontos para análise do agente financeiro." },
    ],
    problems: [
      "Crédito negado por projeto mal estruturado ou orçamento fora da realidade",
      "Perda de prazo da safra enquanto a documentação não fica pronta",
      "Dúvida sobre qual linha usar: custeio, investimento, Pronaf, Pronamp ou RenovAgro",
    ],
    steps: [
      { t: "Diagnóstico", d: "Entendemos a atividade, a área e o objetivo do crédito." },
      { t: "Projeto e orçamento", d: "Elaboramos o projeto técnico e o orçamento conforme a linha escolhida." },
      { t: "Protocolo no banco", d: "Acompanhamos a análise junto ao agente financeiro." },
      { t: "Ajustes e exigências", d: "Respondemos às exigências do agente financeiro até a conclusão da análise." },
    ],
    docs: [
      "CAR, CCIR, ITR e matrícula atualizada",
      "Histórico da atividade e da área de produção",
      "Orçamentos e notas de insumos e máquinas, quando exigido",
      "Documentos pessoais e do CNPJ, quando aplicável",
    ],
    faq: [
      { q: "Quais linhas de crédito vocês trabalham?", a: "As linhas do Plano Safra: custeio, investimento, comercialização, Pronaf, Pronamp e RenovAgro. A linha certa depende do seu caso, e definimos isso no diagnóstico inicial." },
      { q: "Vocês acompanham o crédito depois de liberado?", a: "Nosso foco é o projeto técnico e a documentação. Depois da liberação, seguimos disponíveis para laudos, esclarecimentos e assistência quando o banco solicitar." },
      { q: "O projeto serve para qualquer banco?", a: "Elaboramos o projeto conforme as exigências do agente financeiro escolhido — bancos e cooperativas de crédito que atuam na Metade Sul do RS." },
      { q: "Preciso estar com a documentação do imóvel em dia?", a: "Estar em dia facilita muito a análise. Se houver pendências, cuidamos da regularização em conjunto com a nossa frente de Regularização Rural." },
    ],
  },
  avaliacoes: {
    title: "Avaliações",
    image: "/img/contour.webp",
    intro: "Avaliação técnica de imóveis rurais e urbanos para garantia de crédito rural, negociação, partilha e inventário, seguindo as normas ABNT NBR 14653 — incluindo máquinas, implementos e equipamentos agrícolas.",
    waMsg: "Olá! Preciso de uma avaliação de imóvel.",
    audiences: [
      { t: "Produtores rurais", d: "Valor real da terra para negociar, oferecer em garantia ou planejar a sucessão." },
      { t: "Advogados e escritórios", d: "Laudos que sustentam partilhas, inventários e divisões sem margem para impugnação." },
      { t: "Bancos e cooperativas", d: "Avaliação de garantias de crédito rural em conformidade com as normas técnicas." },
    ],
    problems: [
      "Dúvida sobre o valor real do imóvel na negociação",
      "Exigência de laudo de avaliação pelo banco na operação de crédito",
      "Conflito familiar na partilha ou no inventário por falta de um valor técnico",
      "Laudos que não seguem as normas e não resistem a questionamento",
    ],
    steps: [
      { t: "Definição do objetivo", d: "Entendemos a finalidade: garantia, negociação, partilha ou inventário." },
      { t: "Vistoria e coleta de dados", d: "Visita ao imóvel, levantamento de benfeitorias, solo, acesso e região." },
      { t: "Análise e pesquisa", d: "Pesquisa de mercado e aplicação dos critérios da ABNT NBR 14653." },
      { t: "Laudo final", d: "Documento técnico assinado, pronto para banco, cartório ou juízo." },
    ],
    docs: [
      "Matrícula do imóvel e certidões atualizadas",
      "CCIR, CAR e ITR, no caso de imóveis rurais",
      "Plantas, croquis ou memorial descritivo, quando houver",
      "Relação de benfeitorias conhecidas",
      "Documentos pessoais ou do CNPJ do solicitante",
    ],
    maquinasSection: {
      title: "Avaliação de máquinas e implementos agrícolas",
      text: "Avaliação de máquinas, implementos e equipamentos agrícolas para garantia de crédito rural (penhor de máquinas), negociação e inventário, com laudo conforme a ABNT NBR 14653, aceito por bancos e cooperativas.",
      items: [
        { t: "Identificação do bem", d: "Marca, modelo, número de série, ano e horímetro devidamente registrados." },
        { t: "Estado de conservação", d: "Inspeção presencial da máquina com registro fotográfico do estado atual." },
        { t: "Pesquisa de mercado", d: "Levantamento do valor de mercado do modelo avaliado." },
        { t: "Laudo NBR 14653", d: "Laudo para penhor e garantias, aceito por bancos e cooperativas." },
      ],
    },
    faq: [
      { q: "Que norma rege o laudo de avaliação?", a: "A ABNT NBR 14653, que define os critérios técnicos para avaliação de bens e imóveis no Brasil." },
      { q: "Vocês avaliam imóveis urbanos também?", a: "Sim. A avaliação cobre imóveis rurais e urbanos, e ainda máquinas, implementos e equipamentos agrícolas." },
      { q: "O laudo serve para o banco aceitar o imóvel em garantia?", a: "O laudo segue as normas técnicas exigidas para garantia de crédito rural e é aceito pelas instituições que operam na Metade Sul do RS." },
      { q: "O que influencia o valor de um imóvel rural?", a: "Solo, localização, acesso, benfeitorias, água e a região de comparação. Tudo isso é levantado na vistoria e analisado no laudo." },
      { q: "O que é penhor de máquinas?", a: "É quando a máquina ou o equipamento fica dado em garantia de um crédito rural. O banco exige um laudo técnico que identifique o bem e estime seu valor." },
      { q: "Que informações aparecem no laudo de uma máquina?", a: "Identificação completa do bem (marca, modelo, número de série, ano e horímetro), estado de conservação, pesquisa de mercado e o valor apurado conforme a ABNT NBR 14653." },
    ],
  },
  "laudos-tecnicos": {
    title: "Laudos Técnicos Agronômicos",
    image: "/img/inspect.webp",
    intro: "Laudos técnicos claros e fundamentados para bancos, seguradoras, cartórios e órgãos públicos, com responsabilidade técnica registrada.",
    waMsg: "Olá! Preciso de um laudo técnico agronômico.",
    audiences: [
      { t: "Produtores rurais", d: "Documentação técnica para banco, seguradora ou órgão público sem complicação." },
      { t: "Advogados e escritórios", d: "Pareceres e laudos que sustentam pedidos e defensas em processos rurais." },
      { t: "Bancos e cooperativas", d: "Laudos que confirmam a realidade da produção e da área analisada." },
    ],
    problems: [
      "Exigência de laudo técnico sem saber como conseguir um confiável",
      "Laudo genérico que não descreve a realidade da propriedade",
      "Documentos recusados por falta de fundamentação técnica",
      "Necessidade de comprovar perdas ou condições da lavoura",
    ],
    steps: [
      { t: "Escuta do caso", d: "Entendemos a finalidade do laudo e para quem ele se destina." },
      { t: "Vistoria técnica", d: "Visita à área com coleta de dados e registro fotográfico." },
      { t: "Elaboração", d: "Redação técnica com fundamentação e responsabilidade registrada." },
      { t: "Entrega e sustentação", d: "Laudo pronto para o destino e suporte para eventuais questionamentos." },
    ],
    docs: [
      "Descrição da finalidade do laudo",
      "Matrícula e cadastros do imóvel, quando aplicável",
      "Fotos e informações prévias da área",
      "Documentos do processo, quando judicial",
    ],
    faq: [
      { q: "Para quem os laudos atendem?", a: "Bancos, seguradoras, cartórios e órgãos públicos, além de advogados e produtores que precisam de documentação técnica confiável." },
      { q: "O laudo tem validade jurídica?", a: "É emitido com responsabilidade técnica registrada, o que lhe dá sustentação perante bancos, cartórios e o juízo." },
      { q: "Serve para comprovar perdas de safra?", a: "Sim. A vistoria documenta as condições da lavoura e o laudo registra tecnicamente o que foi constatado." },
      { q: "Quanto tempo leva um laudo?", a: "O prazo depende da complexidade e da finalidade do documento. Informamos o prazo no diagnóstico inicial." },
    ],
  },
  "pericias-judiciais": {
    title: "Perícias Agrícolas e Judiciais",
    image: "/img/soja-vistoria.webp",
    intro: "Atuação como perito judicial em ações que envolvem imóveis rurais e urbanos, lavouras, pecuária, crédito rural e seguro agrícola, com laudos fundamentados na NBR 14653 — além de assistência técnica e pareceres para as partes.",
    waMsg: "Olá! Preciso de perícia judicial ou assistência técnica em um processo.",
    audiences: [
      { t: "Produtores rurais", d: "Defesa técnica dos seus interesses em disputas envolvendo a atividade no campo." },
      { t: "Advogados e escritórios", d: "Assistente técnico, análise crítica de quesitos e laudos, e pareceres para o processo." },
      { t: "Bancos e cooperativas", d: "Esclarecimento técnico sobre perdas, produções e situações discutidas judicialmente." },
    ],
    problems: [
      "Disputa sobre perdas de safra, produção ou área",
      "Questões fundiárias e de demarcação em processo judicial",
      "Laudo da outra parte com falhas técnicas que precisam ser apontadas",
      "Necessidade de responder quesitos com base técnica sólida",
    ],
    steps: [
      { t: "Análise do processo", d: "Leitura dos autos, dos quesitos e das provas existentes." },
      { t: "Vistoria pericial", d: "Inspeção da área ou dos bens com registro técnico e fotográfico." },
      { t: "Laudo ou parecer", d: "Respostas aos quesitos e elaboração do laudo ou do parecer técnico, fundamentado na NBR 14653 quando aplicável." },
      { t: "Sustentação", d: "Apoio técnico ao advogado durante o processo até a decisão." },
    ],
    docs: [
      "Cópia dos autos do processo, quando judicial",
      "Quesitos apresentados pelas partes",
      "Matrícula e cadastros do imóvel",
      "Laudos e documentos anteriores, quando houver",
      "Fotos e mapeamentos disponíveis",
    ],
    faq: [
      { q: "Qual a diferença entre perito e assistente técnico?", a: "O perito é nomeado pelo juízo para esclarecer tecnicamente o processo; o assistente técnico atua por uma das partes, analisando e criticando as questões técnicas." },
      { q: "Que tipos de ação envolvem perícia?", a: "Ações que envolvem imóveis rurais e urbanos, lavouras, pecuária, crédito rural e seguro agrícola — perdas de safra, demarcação, partilhas e disputas contratuais, entre outras." },
      { q: "Como o advogado contrata o serviço?", a: "Basta contatar a equipe com os autos ou as informações do processo. Analisamos o caso e indicamos o melhor caminho técnico." },
      { q: "A perícia serve para acordo extrajudicial?", a: "Serve. A análise técnica também fundamenta acordos e negociações fora do tribunal." },
    ],
  },
  "regularizacao-rural": {
    title: "Regularização Rural",
    image: "/img/furrows.webp",
    intro: "CAR, CCIR, ITR e matrícula atualizada, com análise de matrícula e cadeia dominial e atualização cadastral de imóveis com titular falecido.",
    waMsg: "Olá! Preciso regularizar a documentação da minha propriedade rural.",
    audiences: [
      { t: "Produtores rurais", d: "Documentação em dia para financiar, vender ou herdar sem dor de cabeça." },
      { t: "Advogados e escritórios", d: "Análise de matrícula e cadeia dominial para dar segurança às operações do cliente." },
      { t: "Bancos e cooperativas", d: "Imóvel regularizado é imóvel aceitável em garantia — reduzimos o risco da operação." },
    ],
    problems: [
      "Crédito travado por pendências no CAR, CCIR ou ITR",
      "Imóvel registrado em nome de titular falecido, sem atualização cadastral",
      "Dúvidas na cadeia dominial antes de comprar ou vender",
    ],
    steps: [
      { t: "Análise documental", d: "Levantamento da matrícula, dos cadastros e da cadeia dominial." },
      { t: "Diagnóstico das pendências", d: "Identificação do que está faltando ou incorreto em cada órgão." },
      { t: "Regularização", d: "Providenciamos os ajustes e protocolos junto aos órgãos competentes." },
      { t: "Documentação em dia", d: "Entrega dos documentos atualizados, prontos para banco ou cartório." },
    ],
    docs: [
      "Matrícula do imóvel",
      "Documentos pessoais ou do CNPJ dos titulares",
      "CCIR, CAR e ITR anteriores, quando houver",
      "Certidão de óbito e documentos de herdeiros, no caso de titular falecido",
      "Fotos e informações da propriedade",
    ],
    faq: [
      { q: "O que é o CAR?", a: "O Cadastro Ambiental Rural é o registro eletrônico obrigatório de todas as propriedades rurais, exigido para acesso a crédito e programas públicos." },
      { q: "O imóvel está no nome de quem já faleceu. E agora?", a: "É possível atualizar o cadastro do imóvel com a documentação dos herdeiros. Cuidamos desse processo de atualização cadastral." },
      { q: "Vocês analisam a matrícula antes de uma compra?", a: "Sim. A análise de matrícula e da cadeia dominial mostra a história do imóvel e evita problemas na escritura." },
      { q: "A regularização resolve pendências ambientais?", a: "O CAR é a porta de entrada da regularização ambiental do imóvel. Para questões específicas, avaliamos o caso e indicamos o caminho." },
    ],
  },
  "seguro-agricola": {
    title: "Seguros Agrícolas",
    image: "/img/tractor.webp",
    intro: "Orientação na contratação do seguro agrícola, cobertura Proagro, vistoria e perícia de sinistro, para proteger a lavoura dos riscos do clima.",
    waMsg: "Olá! Preciso de orientação sobre seguro agrícola ou Proagro.",
    audiences: [
      { t: "Produtores rurais", d: "Escolha do seguro certo para a lavoura e apoio firme na hora do sinistro." },
      { t: "Advogados e escritórios", d: "Pareceres técnicos sobre negativas de cobertura e perícia de sinistro." },
      { t: "Bancos e cooperativas", d: "Operações de crédito protegidas, com as apólices em conformidade." },
    ],
    problems: [
      "Lavoura perdida por seca ou excesso de chuva sem cobertura adequada",
      "Sinistro negado por falha na contratação ou na comunicação da perda",
      "Dúvida entre Proagro e seguro agrícola privado",
      "Vistorias mal feitas que não retratam a realidade da lavoura",
    ],
    steps: [
      { t: "Análise de risco", d: "Entendemos a cultura, a área e os riscos da região." },
      { t: "Contratação", d: "Orientação na escolha e no preenchimento correto da apólice." },
      { t: "Comunicação de sinistro", d: "Apoio no aviso e nos prazos quando a perda acontece." },
      { t: "Vistoria e perícia", d: "Vistoria técnica do sinistro e perícia, com documentação técnica para o processo de indenização." },
    ],
    docs: [
      "Apólice ou proposta de seguro",
      "Mapa e croqui da área segurada",
      "Notas de insumos e custos da lavoura",
      "Fotos e registros da perda, quando houver",
      "Documentos pessoais ou do CNPJ",
    ],
    faq: [
      { q: "Qual a diferença entre Proagro e seguro agrícola privado?", a: "O Proagro é o programa público de garantia da atividade agropecuária, geralmente ligado ao crédito rural; o seguro privado é contratado junto a seguradoras. A escolha depende da cultura e da operação." },
      { q: "Vocês fazem a vistoria do sinistro?", a: "Sim. A vistoria técnica documenta a perda e fundamenta o processo de indenização — inclusive com perícia, quando necessário." },
      { q: "Quando o sinistro deve ser comunicado?", a: "Assim que a perda é constatada, respeitando os prazos da apólice. Na dúvida, fale com a equipe imediatamente." },
      { q: "O seguro cobre qualquer perda?", a: "Cada apólice define as coberturas e as exclusões. Por isso a análise na contratação é tão importante quanto a vistoria no sinistro." },
    ],
  },
  "reestruturacao-de-dividas-rurais": {
    title: "Reestruturação de Crédito Rural",
    image: "/img/soja-sunset.webp",
    intro: "Renegociação e prorrogação de dívidas rurais junto aos agentes financeiros, com análise técnica da situação da propriedade e da produção.",
    waMsg: "Olá! Preciso reestruturar ou renegociar uma dívida rural.",
    audiences: [
      { t: "Produtores rurais", d: "Saída organizada da dívida, preservando a propriedade e a capacidade de produzir." },
      { t: "Advogados e escritórios", d: "Pareceres técnicos que sustentam pedidos de renegociação e prorrogação." },
      { t: "Bancos e cooperativas", d: "Propostas tecnicamente consistentes, com base na realidade da produção." },
    ],
    problems: [
      "Dívidas de custeio que comprometem a safra seguinte",
      "Medidas judiciais por inadimplência no crédito rural",
      "Falta de um plano técnico que mostre a capacidade de pagamento",
      "Renegociações mal conduzidas que pioram a situação",
    ],
    steps: [
      { t: "Levantamento das dívidas", d: "Mapeamento de contratos, saldos, garantias e situação da operação." },
      { t: "Análise da produção", d: "Avaliação da capacidade da propriedade e do ciclo da atividade." },
      { t: "Proposta de renegociação", d: "Elaboração técnica da proposta junto ao agente financeiro." },
      { t: "Acompanhamento", d: "Suporte na negociação e no cumprimento do novo acordo." },
    ],
    docs: [
      "Contratos de crédito e boletos",
      "Levantamento de todas as dívidas rurais",
      "Documentos do imóvel e das garantias",
      "Histórico de produção da atividade",
      "Documentos pessoais ou do CNPJ",
    ],
    faq: [
      { q: "Toda dívida rural pode ser renegociada?", a: "Cada caso é analisado com base nos contratos, nas garantias e na situação da produção. O primeiro passo é o levantamento completo da dívida." },
      { q: "O que é prorrogação de dívida rural?", a: "É o alongamento dos pagamentos para outro ciclo, quando a atividade não pôde gerar a renda esperada no prazo original." },
      { q: "Vocês conversam com o banco pelo produtor?", a: "Sim. Elaboramos a proposta técnica e acompanhamos a negociação junto ao agente financeiro." },
      { q: "A propriedade pode ser perdida na renegociação?", a: "A renegociação bem conduzida busca justamente proteger o patrimônio. Por isso a análise técnica vem antes de qualquer proposta." },
    ],
  },
  "assessoria": {
    title: "Assessoria Especializada",
    image: "/img/furrows.webp",
    intro: "Assessoria bancária e jurídica para o agronegócio: contratos de arrendamento, comodato e parceria agrícola, com apoio técnico nas negociações.",
    waMsg: "Olá! Preciso de assessoria para uma negociação ou contrato no agro.",
    audiences: [
      { t: "Produtores rurais", d: "Segurança na assinatura de contratos e nas negociações da propriedade." },
      { t: "Advogados e escritórios", d: "Apoio técnico agronômico e bancário para os contratos e negociações do cliente." },
      { t: "Bancos e cooperativas", d: "Interlocução técnica entre a instituição e o produtor nas operações." },
    ],
    problems: [
      "Contratos de arrendamento ou parceria assinados sem clareza nas obrigações",
      "Negociações com o banco sem entender os detalhes técnicos",
      "Comodatos e parcerias sem documentação adequada",
      "Decisões importantes sem apoio técnico no momento certo",
    ],
    steps: [
      { t: "Entendimento da negociação", d: "Analisamos o objeto, as partes e os riscos envolvidos." },
      { t: "Análise técnica", d: "Avaliação dos termos técnicos, agronômicos e financeiros do acordo." },
      { t: "Apoio à documentação", d: "Orientação sobre contratos e documentos necessários." },
      { t: "Acompanhamento", d: "Suporte durante a negociação e após a assinatura, quando necessário." },
    ],
    docs: [
      "Contratos existentes entre as partes",
      "Matrícula e cadastros do imóvel",
      "Documentos pessoais ou do CNPJ das partes",
      "Descrição da negociação ou do conflito",
    ],
    faq: [
      { q: "Quais contratos vocês acompanham?", a: "Contratos de arrendamento, comodato e parceria agrícola, além de apoios técnicos em negociações do agronegócio." },
      { q: "A assessoria jurídica substitui meu advogado?", a: "Não. Trabalhamos junto com o advogado, levando o conhecimento técnico do campo e do crédito à mesa." },
      { q: "Vocês ajudam a negociar com o banco?", a: "Sim. A assessoria bancária cobre a relação com o agente financeiro nas operações do produtor." },
      { q: "Serve para pequenos produtores?", a: "Sim. A assessoria atende desde a agricultura familiar até grandes operações da Metade Sul do RS." },
    ],
  },
};

module.exports = { SERVICE_SLUGS, SERVICES_DATA, SERVICE_SEO };